import { GridFilterModel, GridSortModel } from '@mui/x-data-grid';
import { AssetSchema } from '@innovyze/lib_asset_schema';

import { Sort } from './types';

/**
 * Grid columns flatten nested List properties (e.g. segments.width → width) for
 * display, but the assets API expects the fully qualified field path for
 * server-side sort/filter (segments.width, segments.material, etc.).
 */
export const resolveServerField = (
	field: string | undefined,
	assetSchema?: AssetSchema,
): string | undefined => {
	if (!field || !assetSchema || field.includes('.')) {
		return field;
	}

	const property = assetSchema.getFlatProperty(field);

	return property?.path.join('.') ?? field;
};

export const convertSortModel = (sort: Sort): GridSortModel => {
	if (sort.sort) {
		return [
			{
				field: sort.sort,
				sort: sort.sortDescending ? 'desc' : 'asc',
			},
		];
	}
	return [];
};

export const removeInvalidEntries = (
	filterModel: GridFilterModel,
): GridFilterModel => {
	const items = filterModel?.items?.filter(
		item =>
			item.value ||
			((item.operator == 'isEmpty' || item.operator == 'isNotEmpty') &&
				!item.value),
	);
	return {
		...filterModel,
		items,
	};
};
